export default "/images/7f87589687d4ca793e6271cafe47d3f2.avif";